import React, { Component } from 'react';
import '../../css/modal.scss';
import { connect } from 'react-redux';
import { httpGet, httpPost, httpUrl } from '../../api/httpClient';
import { Modal } from 'antd';
import image from '../../res/image';
import {modalErrorStyle, modalStyle} from "../../lib/util/codeUtil";

class BlindModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pagination: {
        total: 0,
        current: 1,
        pageSize: 100,
      },
      list: [],
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.getListAsync();
    }
  }

  getListAsync = async () => {
    const self = this;
    try {
      const res = await httpGet(
        httpUrl.blindList,
        [this.state.pagination.pageSize, this.state.pagination.current],
        {}
      );

      if (res.result !== 'SUCCESS') {
        return false;
      }

      self.setState({
        list: res.data.riderFrBlocks,
        pagination: {
          ...self.state.pagination,
          total: res.data.totalCount,
        },
      });
      return true;
    } catch (e) {
      return false;
    }
  };

  removeAsync = async (idx, fn) => {
    try {
      var res = await httpPost(httpUrl.blindRemove, [], { idx });
      if (res.result !== 'SUCCESS') {
        return false;
      }
      fn();
      return true;
    } catch (e) {
      return false;
    }
  };

  removeAllAsync = async (fn) => {
    try {
      var res = await httpPost(httpUrl.blindRemoveAll, [], {});
      if (res.result !== 'SUCCESS') {
        return false;
      }
      fn();
      return true;
    } catch (e) {
      return false;
    }
  };

  onRemoveAll = () => {
    const self = this;
    Modal.confirm({
      ...modalStyle,
      content:
        '블라인드 목록을 전부 삭제하시겠습니까? 한번 삭제하는 경우 다시 불러올 수 없습니다.',
      okText: '확인',
      cancelText: '취소',
      onOk() {
        if (
          self.removeAllAsync(() => {
            self.setState({
              list: [],
              pagination: {
                ...self.state.pagination,
                total: 0,
                current: 1,
              },
            });
          })
        ) {
        } else {
          Modal.error({
            title: '블라인드 처리 오류',
            content: <div>오류가 발생하였습니다. 다시 시도해 주십시오.</div>,
            ...modalErrorStyle,
          });
        }
      },
      onCancel() {},
    });
  };
  onRemove = (idx) => {
    const self = this;
    Modal.confirm({
      ...modalStyle,
      content: '블라인드를 삭제하시겠습니까?',
      okText: '확인',
      cancelText: '취소',
      onOk() {
        if (
          self.removeAsync(idx, () => {
            self.getListAsync();
          })
        ) {
        } else {
          Modal.error({
            title: '블라인드 처리 오류',
            content: <div>오류가 발생하였습니다. 다시 시도해 주십시오.</div>,
            ...modalErrorStyle,
          });
        }
      },
      onCancel() {},
    });
  };

  render() {
    const { isOpen, close } = this.props;
    return (
      <React.Fragment>
        {isOpen ? (
          <React.Fragment>
            <div className="Modal-overlay" onClick={close} />
            <div className="Modal-wide">
              <div className="pw-title">블라인드 목록</div>
              <div className="pw-image" onClick={close}>
                <img style={{ display: 'inline' }} src={image.closeIcon} alt="" />
              </div>
              <div className="blind-content">
                <div className="blind-element-all">
                  <div className="blind-element-block">
                    <div className="blind-element-block-menu">
                      <div className="blind-element-block-menu-text1">
                        등록시간
                      </div>
                      <div className="blind-element-block-menu-text2">
                        기사정보
                      </div>
                      {/* <div className="blind-element-block-menu-text3 mobileoff"></div> */}
                      <div className="blind-element-block-menu-text1">삭제</div>
                    </div>
                  </div>
                  <div className="blind-element-block-field-wrapper">
                    {(!this.state.list || this.state.list.length) === 0 && (
                      <div style={{ textAlign: 'center', padding: '50px' }}>
                        내역이 없습니다.
                      </div>
                    )}
                    {this.state.list
                      .filter((x) => x.direction === 2)
                      .map((row) => {
                        return (
                          <div
                            key={row.idx}
                            className="blind-element-block-field">
                            <div className="blind-element-block-field-text1">
                              {row.createDate}
                            </div>
                            <div className="blind-element-block-field-text2">
                              {row.riderName}
                              <div className="blind-element-block-field-text2-sub">
                                {row.riderPhone}
                              </div>
                            </div>
                            {/* <div className="blind-element-block-field-text3 mobileoff"></div> */}
                            <div className="blind-element-block-field-text1">
                              <div
                                className="blind-element-block-field-btn2"
                                onClick={() => this.onRemove(row.idx)}>
                                삭제
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
                <div className="blind-btn-wrapper">
                  <div className="blind-btn-delete" onClick={this.onRemoveAll}>
                    전체삭제
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { loginReducer } = state;
  return { loginReducer };
};

export default connect(mapStateToProps)(BlindModal);
